import DOWN_DISABLE from 'assets/floor/down-disable.svg';
import DOWN from 'assets/floor/down.svg';
import UP_DISABLE from 'assets/floor/up-disable.svg';
import UP from 'assets/floor/up.svg';
import PARKING_KEYPAD_BACKSPACE from 'assets/parking/keypad-backspace.svg';
import CAR_DEFAULT from 'assets/parking/car-default.svg';
import ALERT from 'assets/parking/alert.svg';

export const ICONS = {
  UP,
  UP_DISABLE,

  DOWN,
  DOWN_DISABLE,

  PARKING_KEYPAD_BACKSPACE,
  CAR_DEFAULT,
  ALERT,
};
